import React, { Component, PropTypes } from 'react'
import Lightbox from "react-image-lightbox"

class ImageLightBox extends Component {
  constructor(props) {
    super(props)
    this.state = {
      lightboxShowed: false
    }
  }

  render() {
    const { lightboxShowed } = this.state
    const { imageSrc='', mainSrc='', clickabled=true } = this.props
    return (
      <div>
        <img
          src={imageSrc}
          className='img-hand' alt='' 
          onClick={() => clickabled && this.setState({ lightboxShowed: true })}
        />
        {lightboxShowed && (
          <Lightbox
            mainSrc={mainSrc} 
            onCloseRequest={() => {
              this.setState({ lightboxShowed: false })
            }}  
          />
        )}
      </div>
    )
  }
}

ImageLightBox.PropTypes = {
  imageSrc: PropTypes.string.isRequired,
  mainSrc: PropTypes.string,
  clickabled: PropTypes.bool
}

export default ImageLightBox


// WEBPACK FOOTER //
// ./src/app/components/normal/pgs/ReportDetail/ImageLightBox.js